import { useEffect, useState } from "react";
import styles from "./styles.module.scss";
import Autocomplete from "@mui/material/Autocomplete/Autocomplete";
import Checkbox from "@mui/material/Checkbox/Checkbox";
import TextField from "@mui/material/TextField/TextField";
import { ChipsSkill } from "../components/Chips";
import { ISoftSkillsDto } from "../../../@types/curriculum.type";
import { getAllSoftSkillReference } from "../../../services/api/Curriculum/SoftSkills/softSkillsService";

interface SoftSkillProps {
  setValue: React.Dispatch<React.SetStateAction<ISoftSkillsDto[]>>;
  softSkills: ISoftSkillsDto[];
  isEdit: boolean;
}

export const SoftSkill: React.FC<SoftSkillProps> = ({
  setValue,
  softSkills,
  isEdit,
}) => {
  const [selectedSkills, setSelectedSkills] = useState<ISoftSkillsDto[]>();
  const [optionsSkills, setOptionsSkills] = useState<ISoftSkillsDto[]>([]);

  useEffect(() => {
    if (selectedSkills) setValue(selectedSkills);
  }, [selectedSkills]);

  useEffect(() => {
    loadInfo();
  }, []);

  const loadInfo = async () => {
    const response = (await getAllSoftSkillReference()) as ISoftSkillsDto[];
    setOptionsSkills(response);
    setSelectedSkills(softSkills);
  };

  return (
    <>
      <div className={styles.softSkill}>
        <div className={styles.divSkills}>
          {isEdit && (
            <Autocomplete
              options={optionsSkills}
              isOptionEqualToValue={(option, value) =>
                option.description == value.description
              }
              getOptionLabel={(option) => option.description || ""}
              value={selectedSkills || []}
              onChange={(_, newValue) => setSelectedSkills(newValue)}
              multiple
              noOptionsText="Sem opções"
              disableCloseOnSelect
              renderOption={(props, option, { selected }) => {
                const { key, ...optionProps } = props;
                return (
                  <li key={option.id} {...optionProps}>
                    <Checkbox style={{ marginRight: 8 }} checked={selected} />
                    {option.description}
                  </li>
                );
              }}
              renderInput={(params) => (
                <TextField
                  {...params}
                  label="Selecione suas Competências"
                  InputLabelProps={{
                    shrink: true,
                  }}
                  fullWidth
                />
              )}
            />
          )}
          <div className={styles.skills}>
            {selectedSkills && selectedSkills.length > 0 && (
              <ChipsSkill skills={selectedSkills} type="softskill" />
            )}
          </div>
        </div>
      </div>
    </>
  );
};
